<template>
  <footer class="bg-gray-300 flex-shrink-0 p-4">
    <div class="flex flex-col w-full max-w-6xl my-0 mx-auto">
      <LangSelector />

      <div class="flex flex-col items-center my-3">
        <div class="flex text-center items-center md:block md:text-left lg:text-center">
          <Link :href="link.legalPoliciesPrivacy" tc="LegalPoliciesPrivacy" class="info-link">
            {{ lang.legalPoliciesPrivacy }}
          </Link>
          <span class="info-dot text-gray-500 mx-2">&bull;</span>
          <Link :href="link.contactUs" tc="ContactUs" class="info-link">
            {{ lang.contactUs }}
          </Link>
          <span class="info-dot text-gray-500 mx-2">&bull;</span>
          <Link :href="link.trendMicro" tc="TrendMicro" class="info-link">
            {{ lang.brandedTitle }}
          </Link>
        </div>

        <div class="text-gray-700 text-xs text-center mt-2">
          {{ $f(lang.copyrightStatement, { year: new Date().getFullYear() }) }}<br />
          {{ lang.allRightReserved }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

import Link from '@/components/Link.vue';
import LangSelector from '@/components/LangSelector.vue';

export default {
  name: 'MobileFooter',
  components: {
    Link,
    LangSelector,
  },
  computed: {
    ...mapState(['userLang', 'lang']),
    link() {
      return {
        legalPoliciesPrivacy: `https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=Privacy&Locale=${this.userLang}`,
        contactUs: `https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=ContactUs&Locale=${this.userLang}`,
        trendMicro: `https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=TrendMicro&Locale=${this.userLang}`,
      };
    },
  },
};
</script>

<style scoped>
.info-link {
  @apply text-blue-500;
}

@media (max-width: 720px) {
  footer {
    background-image: none;
  }
}

@media (max-width: 360px) {
  .info-link {
    flex: 1;
  }

  .info-dot {
    margin: 0 0.125rem;
  }
}
</style>
